import { useState } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const PHOTOS = [
  {
    src: '/media/img19.jpg',
    alt: '연습장 사진 1',
  },
  {
    src: '/media/img20.jpg',
    alt: '연습장 사진 2',
  },
];

export default function LocationSection() {
  const ref = useScrollAnimation<HTMLDivElement>();
  const [selectedPhoto, setSelectedPhoto] = useState<string | null>(null);

  return (
    <section id="company" className="bg-white">
      <div className="bg-primary py-12 md:py-16 px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl md:text-4xl font-bold text-white text-center">오시는 길</h1>
        </div>
      </div>
      <div ref={ref} className="scroll-animate py-16 md:py-24 px-4 md:px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {PHOTOS.map((photo) => (
            <button
              key={photo.src}
              type="button"
              onClick={() => setSelectedPhoto(photo.src)}
              className="relative aspect-[4/3] overflow-hidden rounded-lg bg-gray-100 cursor-pointer group"
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-sm">
                  <i className="ri-zoom-in-line text-gray-800 text-xl" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {selectedPhoto && (
        <div
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4 md:p-8"
          onClick={() => setSelectedPhoto(null)}
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            onClick={() => setSelectedPhoto(null)}
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
            aria-label="닫기"
          >
            <i className="ri-close-line text-white text-xl" />
          </button>
          <img
            src={selectedPhoto}
            alt="확대 보기"
            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}